import { useEffect } from "react";

const DARK_MODE_STORAGE_KEY = "breward-theme";

const getStoredTheme = () => {
  if (typeof window === "undefined") {
    return undefined;
  }

  return window.localStorage.getItem(DARK_MODE_STORAGE_KEY);
};

const prefersDarkMode = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-color-scheme: dark)").matches;

const updateDarkModeClass = (theme?: string | null) => {
  if (typeof document === "undefined") {
    return;
  }

  const useDark = theme === "dark" || (!theme && prefersDarkMode());
  document.documentElement.classList.toggle("dark", useDark);
};

export const useDarkModeClass = () => {
  useEffect(() => {
    updateDarkModeClass(getStoredTheme());

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleSystemThemeChange = () => {
      updateDarkModeClass(getStoredTheme());
    };
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === DARK_MODE_STORAGE_KEY) {
        updateDarkModeClass(event.newValue);
      }
    };

    mediaQuery.addEventListener("change", handleSystemThemeChange);
    window.addEventListener("storage", handleStorageChange);

    return () => {
      mediaQuery.removeEventListener("change", handleSystemThemeChange);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
};
